import { MESSAGE_TEMPLATES, MessageTemplate } from './messageTemplates';

type Props = {
  selectedId: string | null;
  onSelect: (template: MessageTemplate) => void;
};

/** Picker for the candidate email templates. */
export const Templates = ({ selectedId, onSelect }: Props) => (
  <fieldset className="flex flex-col gap-2">
    <legend className="mb-1 text-sm font-medium text-gray-700">Template</legend>
    {MESSAGE_TEMPLATES.map((template) => (
      <label
        key={template.id}
        className={`flex cursor-pointer items-start gap-3 rounded-lg border p-3 ${
          selectedId === template.id
            ? 'border-red-400 bg-red-50'
            : 'border-gray-200 bg-white'
        }`}
      >
        <input
          type="radio"
          name="message-template"
          className="mt-1"
          checked={selectedId === template.id}
          onChange={() => onSelect(template)}
        />
        <span>
          <span className="block text-sm font-semibold text-gray-900">
            {template.name}
          </span>
          <span className="block text-xs text-gray-500">{template.subject}</span>
        </span>
      </label>
    ))}
  </fieldset>
);
